
import React from 'react';

interface ArticleHeaderImageProps {
  imageUrl?: string;
  title: string;
}

const ArticleHeaderImage = ({ imageUrl, title }: ArticleHeaderImageProps) => {
  if (!imageUrl) return null;
  
  return (
    <div className="w-full h-[40vh] md:h-[50vh] bg-muted relative">
      <img 
        src={imageUrl} 
        alt={title}
        className="w-full h-full object-cover"
        onError={(e) => {
          (e.target as HTMLImageElement).src = 'https://via.placeholder.com/1200x675?text=Image+Not+Found';
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-background to-transparent opacity-70"></div>
    </div>
  );
};

export default ArticleHeaderImage;
